import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { forwardRef as u } from "react";
const v = 32;
function f(r) {
  switch (r) {
    case "current":
      return "var(--text-on-accent)";
    case "on-brand":
      return "var(--text-on-accent)";
    case "brand":
    default:
      return "var(--text-on-accent)";
  }
}
function h(r) {
  switch (r) {
    case "on-brand":
      return "var(--brand-primary)";
    case "current":
      return "currentColor";
    case "brand":
    default:
      return "var(--brand-primary)";
  }
}
const b = u(function({ size: n = v, tone: a = "brand", className: i, "aria-label": o }, l) {
  const d = h(a), s = f(a), t = !o;
  return /* @__PURE__ */ c(
    "svg",
    {
      ref: l,
      width: n,
      height: n,
      viewBox: "0 0 64 64",
      role: t ? "presentation" : "img",
      "aria-label": t ? void 0 : o,
      "aria-hidden": t ? !0 : void 0,
      "data-wave-logo": !0,
      "data-tone": a,
      className: ["ls-wave-logo", i].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ e("rect", { width: "64", height: "64", rx: "14", fill: d }),
        /* @__PURE__ */ c("g", { transform: "translate(7 13.5) scale(0.0835)", fill: s, children: [
          /* @__PURE__ */ e("path", { d: "M324.39,230.961c-13.048,84.215,36.032,163.264,100.016,213.188,37.97,29.626,86.7,53.186,133.751,64.055,9.706,2.243,26.25,3.318,34.336,6.654,9.455,3.9,8.373,19.065-1.515,22.142l-526.86.7c-49.877-5.6-56.137-49.449-61.262-90.589-7.808-62.68-.248-129.2,30.657-184.849,22.254-40.074,70.669-87.971,121.06-75.762,31.212,7.563,34.31,34.023,54.925,51.971,33.327,29.015,85.742,25.48,114.892-7.507" }),
          /* @__PURE__ */ e("path", { d: "M434.293,115.084c17.044,21.072,24.092,49.686,15.444,75.875C437.1,229.225,391.2,249.224,355.45,228.383c-3.708-2.162-15.557-10.706-16.659-14.376-.968-3.224,3.107-16.572,3.464-21.637a72.944,72.944,0,0,0-36.348-68.284c2.229,5.118,6.3,9.032,9.02,13.948,26.139,47.317-7.02,108.106-63.685,97.652-37.192-6.861-37.122-34.212-60.7-54.189-30.055-25.464-71.039-21.9-103.932-4-29.356,15.973-50.721,40.929-68.9,68.454,34.085-109.658,121.921-200.9,233-233.038,94.879-27.455,203.536-12.12,277.509,55.7,25.094,23.006,64.4,73.3,69.645,107.181,13.721,88.586-102.654,130.252-145.423,51.819,31.512-31.379,25.637-95.436-18.144-112.522" })
        ] })
      ]
    }
  );
});
export {
  b as W
};
//# sourceMappingURL=WaveLogo-BRI9e50e.js.map
